export const isExternalLink = (url: string | undefined): boolean => {
  if (!url) return false;
  const linkElement = document.createElement("a");
  linkElement.href = url;
  return linkElement.hostname !== window.location.hostname;
};
